import "./index.css";
import { opsConsoleRedirectUrl } from "./lib/ops-host-routing";

const opsRedirect = opsConsoleRedirectUrl(window.location);

if (opsRedirect) {
  window.location.replace(opsRedirect);
} else {
  // Prerendered knowledge pages (see scripts/prerender.mjs) ship JSON-LD in the
  // static HTML so no-JS crawlers see structured data. The client <Seo> component
  // re-adds it after mount, so remove the prerendered copies first to avoid dupes.
  document
    .querySelectorAll('script[data-prerender-jsonld="true"]')
    .forEach((el) => el.remove());

  const root = document.getElementById("root");
  if (!root) throw new Error("Missing application root");

  const isHomepageDemo = window.location.pathname
    .replace(/\/+$/, "")
    .endsWith("/homepage-demo");

  if (isHomepageDemo) {
    void import("./homepage-demo-bootstrap").then(({ mountHomepageDemo }) => {
      mountHomepageDemo(root);
    });
  } else {
    void Promise.all([
      import("react-dom/client"),
      import("./lib/sentry"),
      import("./App"),
    ]).then(([{ createRoot }, { initSentry }, { default: App }]) => {
      initSentry();
      createRoot(root).render(<App />);
    });
  }
}
